<div class="gr-canvas-item__surface relative flex min-h-0 min-w-0 flex-auto rounded-lg">
  <div class="gr-canvas-item__content flex min-h-0 min-w-0 flex-auto flex-col overflow-hidden">
    <ng-content />
  </div>

  @if (editing()) {
    <div class="gr-canvas-item__toolbar" role="toolbar" aria-label="Widget actions">
      <button
        type="button"
        class="gr-canvas-item__tool gr-canvas-item__tool--handle inline-flex h-7 w-7 cursor-pointer items-center justify-center rounded-sm border-0 bg-transparent"
        (pointerdown)="onDragHandlePointerDown($event)"
        [attr.aria-label]="'Drag ' + item().id"
        grTooltip="Drag to move"
        grTooltipPosition="top"
      >
        <span class="material-icons-outlined" aria-hidden="true">drag_indicator</span>
      </button>
      <span class="gr-canvas-item__tool-divider" aria-hidden="true"></span>
      <button
        type="button"
        class="gr-canvas-item__tool inline-flex h-7 w-7 cursor-pointer items-center justify-center rounded-sm border-0 bg-transparent"
        [attr.aria-label]="'Edit ' + item().id"
        grTooltip="Configure"
        grTooltipPosition="top"
        (click)="onEdit($event)"
      >
        <span class="material-icons-outlined" aria-hidden="true">tune</span>
      </button>
      <button
        type="button"
        class="gr-canvas-item__tool gr-canvas-item__tool--danger inline-flex h-7 w-7 cursor-pointer items-center justify-center rounded-sm border-0 bg-transparent"
        [attr.aria-label]="'Remove ' + item().id"
        grTooltip="Remove"
        grTooltipPosition="top"
        (click)="onRemove()"
      >
        <span class="material-icons-outlined" aria-hidden="true">close</span>
      </button>
    </div>

    @if (resizable()) {
      <div
        class="gr-canvas-item__resize gr-canvas-item__resize--right"
        (pointerdown)="startResize('right', $event)"
        aria-hidden="true"
      ></div>
      <div
        class="gr-canvas-item__resize gr-canvas-item__resize--bottom"
        (pointerdown)="startResize('bottom', $event)"
        aria-hidden="true"
      ></div>
      <button
        type="button"
        class="gr-canvas-item__grip"
        (pointerdown)="startResize('corner', $event)"
        [attr.aria-label]="'Resize ' + item().id"
        grTooltip="Drag to resize"
        grTooltipPosition="top"
      >
        <span class="gr-canvas-item__grip-lines" aria-hidden="true"></span>
      </button>
    }
  }
</div>
